<template>
<div>
    <div class="container is-child has-text-centered">
              <article class="is-parent title">
                  <h1 class="title">Live Game</h1>
                  <button class="button is-primary" @click="startGame()">Start Game</button>
                  <button class="button is-warning">End Game</button>
        </article>
        <article class="container is-child box">
            <h1 class="title">Game Time</h1>
            <p>{{time}}</p>
            <button class="button is-info">Pause</button>
            <button class="button is-info">+</button>
            <button class="button is-info">-</button>
            <button class="button is-info">Reset</button>
        </article>
         <article class="container is-child box">
            <p class="title">Period - 1</p>
        </article>
         <article class="container is-child box">
            <p class="title">Situation - Even Handed 5v5</p>
        </article>
        <article class="container is-child box">
            <p class="title">Game State - Even</p>
        </article>
     </div>
</div>
</template>

<style  lang="scss" scoped>
@import '~bulma/sass/utilities/mixins';
.small {
  font-size: 1em;
  display: inline-block;
}
.title {
    font-size: 23px;
}
.is-horizontal-center {
  justify-content: center;
}
.columns{
    flex-wrap: wrap;
    align-items: stretch;
    justify-content: center;

}
.button {
  margin: 5px 0 0;
}
.is-child.box:hover{
background-color: rgba(250, 250, 250, 0.678);
color: #00d1b2;
cursor: pointer;
}
.is-child.box:hover p{
color: #00d1b2;
cursor: pointer;
}
.team_logo {
  width: 62px;
  height: 62px;
  border-radius: 50%;
display: block;
    margin-left: auto;
    margin-right: auto;

}
.control .button {
  margin: inherit;
}
.select select{
  font-size: 0.8em;
}
.select{
   height:1.5em;
   font-size:16px;
}
.control.has-addons {
  @include mobile() {
    input {
      width: 100%;
    }

    input.is-expanded {
      flex-shrink: 1;
    }
  }
}
</style>

<script>

export default {
  name: '',
  data () {
    return {
      GameState: [],
      time: 0
    }
  },
  methods: {
    startGame () {
      this.updateTime()
    },
    endGame () {

    },
    updateTime: function () {
      this.$http.get('https://devilsapi.roblutken.com/api/live/time', { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        this.time = response.data
        console.log(this.time)
      }, response => {
      })
    }
  },
  created: function () {
    this.$http.get('https://devilsapi.roblutken.com/api/live/start', { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
    response => {
      // this.time = response.data
      console.log('Start session')
    }, response => {
    })
  },
  update: function () {

  },
  mounted: function () {
    console.log('Mounted')
    // Run every 30 seconds
    setInterval(function () {
      console.log('Poll Update')
      this.updateTime()
    }.bind(this), 1200)
  }
}

</script>



// WEBPACK FOOTER //
// game-night-live.vue?27fe7c4c